import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import product from './modules/product';
import fastQuery from './modules/fastQuery';
import queryCard from './modules/queryCard';
import account from './modules/account';
import fastQueryOld from './modules/fastQueryOld';
import accAssign from './modules/accountAssign';
import changeIp from './modules/changeIp';
import changeIpRate from './modules/changeIpRate';
import merchant from './modules/merchant';
import agent from './modules/agent';
import permission from './modules/permission';
import getters from './getters';
import productImsi from './modules/productImsi';
import usageStat from "./modules/usageStat";
import cdrToday from "./modules/cdrToday";
import role from "./modules/role";
import rechargeLog from "./modules/rechargeLog";
import topUpLog from "./modules/topUpLog";
import userOperateLog from "./modules/userOperateLog";
import moudle from "./modules/moudle";
import orderExcel from "./modules/orderExcel";
import orderProduct from "./modules/orderProduct";
import orderAccAssign from "./modules/orderAccAssign";
import otaProduct from "./modules/otaProduct";
import otaSim from "./modules/otaSim";
import cdrSimList from "./modules/cdrSimList";
import taskTopup from "./modules/taskTopup";
import withdrawLog from "./modules/withdrawLog";
import agentIpFeeLog from "./modules/agentIpFeeLog";
import esimPurchase from "./modules/esimPurchase";

Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        app,
        user,
        fastQuery,
        queryCard,
        product,
        account,
        accAssign,
        changeIp,
        changeIpRate,
        fastQueryOld,
        merchant,
        agent,
        permission,
        productImsi,
        usageStat,
        cdrToday,
        role,
        rechargeLog,
        topUpLog,
        userOperateLog,
        moudle,
        orderExcel,
        orderProduct,
        orderAccAssign,
        otaProduct,
        otaSim,
        cdrSimList,
        taskTopup,
        withdrawLog,
        agentIpFeeLog,
        esimPurchase
    },
    getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js